import React, { Component } from 'react';
import Notifications from 'react-notify-toast';
import Router from './Router';
import './App.css';

class App extends Component {
  render() {
    return (
      <div>
        <Notifications />
        <Router />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js